import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { confirm } from 'devextreme/ui/dialog';
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { CustomerConnectionService } from "./customer-connection.service";
import { Router } from "@angular/router";
import { SharedService } from "src/app/services/SharedService";
import { Constants } from "src/app/common/constants";
import { NotificationTypes } from "src/app/common/component/notification/notification.component";
import { ProductUOMConversionsService } from "src/app/common/service/productuomconversions.service";
import { lastValueFrom } from "rxjs";

@Component({
    selector: 'customer-connection',
    templateUrl: './customer-connection.component.html',
    styleUrls: ['./customer-connection.component.scss']
})

export class CustomerConnectionComponent {
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    customerConnections: any;
    customerConnectionDataSource: DataSource;
    @Input() pipelineId: number;
    @Input() sites: any;
    @Input() uoms: any;
    @Input() materialId: any;
    @Input() pipelineCode: any;
    @Input() materialName: any;
    @Output() setLoadPanelVisibility: EventEmitter<boolean> = new EventEmitter();
    constructor(private router: Router, private customerConnectionService: CustomerConnectionService, private notificationService: NotificationService, private sharedSvc: SharedService,
        private productUOMConversionsService: ProductUOMConversionsService) {
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.editCustomerSite = this.editCustomerSite.bind(this);
        this.setUOMValue = this.setUOMValue.bind(this);
    }

    ngAfterViewInit(): void {
        this.getCustomerConnections();
    }

    addCustomerConnection(event) {
        event.data.pipelineId = this.pipelineId;
        event.data.supplyDemandConnectionId = 0;
        event.data.materialId = this.materialId;
        this.setLoadPanelVisibility.emit(true);
        this.customerConnectionService.addCustomerConnection(event.data).subscribe({
            next: customerConnections => {
                this.customerConnectionDataSource = new DataSource({
                    store: new ArrayStore({
                        data: customerConnections,
                        key: 'supplyDemandConnectionId',
                    })
                });
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert('success', 'Customer connection created successfully!', null);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while fetching Supply Demand Connections", error);
            }
        });
    }

    async setUOMValue(rowData: any, value: any, currentRowData: any) {

        if (this.materialName == "") {
            this.materialName = this.uoms.filter(x => x.productId == this.materialId)[0].productLongDesc;
        }

        rowData.uom = value;
        if ([Constants.material_Syngas, Constants.material_Steam, Constants.material_Other].indexOf(this.materialId) > -1) {
            this.notificationService.alert(NotificationTypes.Warning, "Please calculate the Quantity manually and update the same", null);

            return rowData;
        } else {
            if (currentRowData.uom && currentRowData.quantity) {
                var conversionDataPromise = this.productUOMConversionsService.getProductUOMConversion(this.materialName, 'Gas', currentRowData.uom, value)
                var conversionData = await lastValueFrom(conversionDataPromise);
                rowData.quantity = (currentRowData.quantity * eval(conversionData.conversionFactorValue)).toFixed(4);
                return rowData;
            }
        }
    }

    editCustomerSite(e) {

        this.sharedSvc.previousRouteToEditSite = "/pipelines/" + this.pipelineId + '/' + this.materialId;
        var siteId = e.row.data.customerSiteId;

        this.router.navigate(["/editsite/" + siteId]);
        return false;
    }

    deleteCustomerConnection(event) {
        event.data.pipelineId = this.pipelineId;
        event.data.materialId = this.materialId;
        this.setLoadPanelVisibility.emit(true);

        this.customerConnectionService.deleteCustomerConnection(event.data.supplyDemandConnectionId).subscribe({
            next: customerConnections => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert('success', 'Customer connection deleted successfully!', null);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while deleting Customer connection", error);
            }
        });
    }

    updateCustomerConnection(event) {
        event.data.pipelineId = this.pipelineId;
        event.data.materialId = this.materialId;
        this.setLoadPanelVisibility.emit(true);

        this.customerConnectionService.updateCustomerConnection(event.data).subscribe({
            next: customerConnections => {
                this.customerConnectionDataSource = new DataSource({
                    store: new ArrayStore({
                        data: customerConnections,
                        key: 'supplyDemandConnectionId',
                    })
                });
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert('success', 'Customer connection updated successfully!', null);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while updating Customer connection", error);
            }
        });

    }

    getCustomerConnections() {
        this.setLoadPanelVisibility.emit(true);
        this.customerConnectionService.getCustomerConnections(this.pipelineId).subscribe({
            next: customerConnections => {
                this.customerConnectionDataSource = new DataSource({
                    store: new ArrayStore({
                        data: customerConnections,
                        key: 'supplyDemandConnectionId',
                    })
                });
                this.setLoadPanelVisibility.emit(false);
            }, error: (error) => {
                this.setLoadPanelVisibility.emit(false);
                this.notificationService.alert("error", "Error while fetching Customer connections", error);
            }
        });
    }

    onCustomerGridToolbarPreparing(event) {
        let toolbarItems = event.toolbarOptions.items;
        let addRowButton = toolbarItems.find(x => x.name === "addRowButton");
        addRowButton.options.text = "Add Customer Connection";
        addRowButton.options.type = 'default';
        addRowButton.options.icon = '';
        addRowButton.showText = "always";
    }

    onSaveClick(e) {
        this.dataGrid.instance.saveEditData();
        this.dataGrid.instance.columnOption('uom', 'caption', 'Uom');
    }

    onCancelClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.dataGrid.instance.cancelEditData();
                that.dataGrid.instance.columnOption('uom', 'caption', 'Uom');
            }
        });
    }
}